export default __webpack_public_path__ + "static/fonts/BeVietnamPro-Medium.ttf";